import React from 'react';

const ImpersonationBanner = ({ impersonationData, onExitImpersonation, isExiting }) => {
  if (!impersonationData) return null;

  return (
    <div className="bg-gradient-to-r from-amber-600 via-orange-600 to-amber-700 text-white px-4 py-2 shadow-md relative z-50 flex items-center justify-between text-xs animate-fadeIn">
      <div className="flex items-center gap-2.5 flex-wrap">
        <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
          <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        <div className="flex items-center gap-2">
          <span className="font-bold tracking-wide uppercase text-[10px] bg-black/20 px-1.5 py-0.5 rounded">
            Impersonation Active
          </span>
          <span>
            Acting as <strong className="underline">{impersonationData.target_user?.username || impersonationData.username}</strong> ({impersonationData.target_user?.role || impersonationData.role}) for organization <strong>{impersonationData.target_user?.client_name || impersonationData.client_name}</strong>
          </span>
          {impersonationData.is_read_only && (
            <span className="inline-flex items-center gap-1 bg-blue-900/60 text-blue-100 font-semibold px-2 py-0.5 rounded-full text-[10px] border border-blue-400/30">
              <svg className="w-2.5 h-2.5 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span>Safe / Read-Only Mode</span>
            </span>
          )}
        </div>
      </div>

      <button
        onClick={onExitImpersonation}
        disabled={isExiting}
        className="px-3 py-1 bg-white hover:bg-amber-50 active:bg-amber-100 text-amber-900 font-bold rounded-lg shadow-sm hover:shadow transition-all flex items-center gap-1.5 flex-shrink-0 ml-3"
      >
        <svg className="w-3.5 h-3.5 text-amber-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        <span>{isExiting ? 'Restoring...' : 'Exit Impersonation'}</span>
      </button>
    </div>
  );
};

export default ImpersonationBanner;
